import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material';
import { TravelCashService } from '../../services/travel-cash/travel-cash.service';
import { travelCashUrl, travelAuthorUrl } from 'src/app/modules/shared/common/api';
import { TravelCashApproveListComponent } from '../travel-cash-approve-list/travel-cash-approve-list.component';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { TravelItineraryViewComponent } from 'src/app/modules/shared/components/travel-itinerary-view/travel-itinerary-view.component';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';

@Component({
  selector: 'app-travel-cash-advance-add',
  templateUrl: './travel-cash-advance-add.component.html',
  styleUrls: ['./travel-cash-advance-add.component.scss']
})
export class TravelCashAdvanceAddComponent implements OnInit {

  travel: Travel;
  user: User;
  formGroup: FormGroup;
  searchGroup: FormGroup;
  loading:boolean = false;
  listResult:boolean = false;
  isNoResult:boolean = false;
  isCharged:boolean = false;
  isCurrency:boolean = false;
  isOther:boolean = false;
  successMessage: String = '';
  total = 0;
  mealTotal = 0;
  transportFee = 0;
  taList:any; //Travel Authorization Number
  objectKeys = Object.keys;
  expensesList:any;

  travelOption = ["Individual","Group"];
  purposeOption = ["Store Opening Setup","HR Meeting","Others"];
  natureOption = ["Inbound","Outbound"];
  currencyOption = [
    {id:1,name:"PHP"},
    {id:2,name:"USD"},
    {id:3,name:"Others"}
  ];
  chargeOption = [
    {id:1,name:"Rose Pharmacy"},
    {id:2,name:"DF"},
    {id:3,name:"Supplier"}
  ];
  bookedOption = ["Office Booking","Self Booking"];
  billOption = ["Store Support Center","Requestor"];

  dialogConfig:any;
  summaryDetail:any;
  departmentList = JSON.parse(localStorage.getItem('department'));
  positionList = JSON.parse(localStorage.getItem('position'));

  province = [
    {
      origin:'',
    },
    {
      destination: ''
    }
  ];

  city = [
    {
      city:''
    },
    {
      city: ''
    }
  ];

  barangay = [
    {
      barangay:''
    },
    {
      barangay: ''
    }
  ];
 

  pipe = new DatePipe('en-US');

  constructor(
    public dialogRef: MatDialogRef<TravelCashAdvanceAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelCashService: TravelCashService,
    private formBuilder: FormBuilder,
    public functionService: FunctionsService,
    public travelService: TravelService,
    public auth: AuthService,
    

    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.travel = new Travel({});
    this.user = new User(this.auth.getAuthUser());
    this.formGroup = this.formBuilder.group({
      date_filed:['',null],
      itinerary_date: ['',null],
      travel_authorization_no: ['',null],
      travel_authorization_id: ['',null],
      complete_name:['',null],
      employee_id_no: ['',null],
      position: ['',null],
      department: ['',null],
      area_covered: ['',null],
      payroll_acct_no: ['',null],
      travel_type: ['',null],
      copy_date: ['',null],
      purpose: ['',null],
      location: ['',null],
      nature: ['',null],
      inclusive_date_from: ['',null],
      inclusive_date_to: ['',null],
      representation:['',null],
      miscellaneous:['',null],
      currency: ['',null],
      amount: ['',null],
      charged_to: ['',null],
      booked_by: ['',null],
      bill_to: ['',null],
      is_draft: ['',null],
      accomodation: ['',null],
      currency_category: ['',null],
      type:['travel',null],
      charged_to_category: ['',null],
      travel_itinerary_details:['',null],
      is_lunch:['',null],
      is_dinner:['',null],
      is_breakfast: ['',null],
      meal:['',null],
      per_diem:['',null],
      misc_breakdown:['',null],
      others:['',null],
    });
    this.data = {
      isOther:false,
      res: {}
    };
    this.travel.formGroup = this.formGroup;
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';

  }
  
  closeOnClick() {
    this.dialogRef.close('');
  }
  
  getTransaction(){
    let param = [];
    let queryString = '';

    param.push('type=for-cash-advance');

    if(this.formGroup.controls['travel_authorization_no'].value !== null){
      param.push('travel_authorization_no='+this.formGroup.controls['travel_authorization_no'].value);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }
    this.data.isOther = true;
    this.loading = true;
    this.isNoResult = false;
    this.travelCashService.url = travelAuthorUrl+'/approved/'+ queryString;
    this.travelCashService.getFilter().subscribe(res=>{
      if (res.length > 0) {
        this.travel = new Travel(res[0]);
        this.travel.formGroup = this.formGroup;
        this.travel.disableForm();
        this.travel.formGroup.controls['travel_authorization_no'].enable();
        this.travel.formGroup.controls['misc_breakdown'].enable();
        this.travel.formGroup.controls['type'].enable();
        this.travel.formGroup.controls['travel_authorization_id'].enable();
        this.travel.formGroup.controls['is_draft'].enable();
        this.formGroup.controls['employee_id_no'].setValue(this.user.employee_id);

        this.formGroup.controls['area_covered'].setValue(res[0].area_covered);
        this.formGroup.controls['amount'].setValue(res[0].travel_summary.amount);
        this.formGroup.controls['bill_to'].setValue(res[0].travel_summary.bill_to);
        this.formGroup.controls['position'].setValue(res[0].position);
        this.formGroup.controls['department'].setValue(res[0].department);
        this.formGroup.controls['payroll_acct_no'].setValue(res[0].payroll_acct_no);
        this.formGroup.controls['booked_by'].setValue(res[0].travel_summary.booked_by);
        this.formGroup.controls['charged_to'].setValue(res[0].travel_summary.charged_to);
        this.formGroup.controls['currency'].setValue(res[0].travel_summary.currency);
        this.formGroup.controls['currency_category'].setValue(res[0].travel_summary.currency_category);
        this.formGroup.controls['charged_to_category'].setValue(res[0].travel_summary.charged_to_category);
        this.formGroup.controls['inclusive_date_from'].setValue(res[0].travel_summary.inclusive_date_from);
        this.formGroup.controls['inclusive_date_to'].setValue(res[0].travel_summary.inclusive_date_to);
        this.formGroup.controls['location'].setValue(res[0].travel_summary.location);
        this.formGroup.controls['nature'].setValue(res[0].travel_summary.nature);
        //this.formGroup.controls['purpose'].setValue(res[0].travel_summary.purpose);
        this.formGroup.controls['travel_type'].setValue(res[0].travel_summary.travel_type);
        this.formGroup.controls['travel_authorization_id'].setValue(res[0].id);
        this.formGroup.controls['itinerary_date'].setValue(res[0].itinerary_date);
        this.formGroup.controls['others'].setValue(res[0].travel_summary.others);
        let purposeOption = res[0].travel_summary.purpose.split("|");
        this.formGroup.controls['purpose'].setValue(purposeOption[0]);
        if (purposeOption[0] == "Others") {
          this.isOther = true;
         // this.formGroup.controls['others'].setValue(purposeOption[1]);
        }

        this.travel.itineraries = res[0].travel_itineraries;
        this.expensesList  = this.functionService.loopRangeDate(
          [res[0].travel_summary.inclusive_date_from,res[0].travel_summary.inclusive_date_to],
          res[0].travel_itineraries
        );
        this.travel.getTotal();
        this.data.res = res[0];
      } else {
        this.travel.id = null;
        this.isNoResult = true;
      }
      this.loading = false;
    });
  }

  save(draft:boolean){
    this.loading = true;
    this.formGroup.controls['is_draft'].setValue(draft);
    this.travelCashService.storeCash(this.formGroup.value).subscribe(res=>{
      
      this.loading = false;
      this.dialog.open(NotifyboxComponent, {
        disableClose:true,
        data: {
          reload:false,
          label:'Ok',
          isclose:true,
          message: res['message']
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(this.formGroup.value);
        }
      });

    },(err => {
      this.loading = false;
      this.travel.formGroup = this.formGroup;
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
    }));
  }

  approvelist() {
    this.dialogConfig.width = '100vw';
    let dialogRef = this.dialog.open(TravelCashApproveListComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.formGroup.controls['travel_authorization_no'].setValue(result.travel_authorization_no);
      }
    });
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/\d/); // '\d'
     return pattern.test(e.key);
  }

  /**
   * Display Currency option
   * @param e = 3 get value for other currency
   */
  displayCurrency(e) {
    this.isCurrency = false;
    this.formGroup.get('currency_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCurrency = true;
      }
    })
  }

  /**
   * Display other supplier
   * @param e  e = 3 get value for supplier
   */
  displayCharge(e) {
    this.isCharged = false;
    this.formGroup.get('charged_to_category').valueChanges.subscribe(value => { 
      if (value == 3) {
        this.isCharged = true;
      }
    })
  }

   /**
   * View itinerary Details Modal
   * @param res 
   */
  viewItinerary(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.travel.booking_details_list,
      mode: 1,
      displayEdit: false
    }
    let dialogRef = this.dialog.open(TravelItineraryViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  searchKey(e){
    if (e.target.value.length > 2) {
      this.travelCashService.url = travelAuthorUrl +'/approved'+'?type=for-cash-advance&travel_authorization_no='+e.target.value;
      this.travelCashService.getFilter().subscribe(res=>{
        this.listResult = true;
        this.taList = res;
      });
    }

  }

}
